import { FilterNone } from '@mui/icons-material';
import { Button } from '@mui/material';
import LogoutIcon from '@mui/icons-material/Logout';

interface IProps {
  isActive: boolean;
  onClick: () => void;
}

const ComparationToggleButton = ({ isActive, onClick }: IProps) => {
  return (
    <Button
      variant="contained"
      color="primary"
      startIcon={!isActive ? <FilterNone /> : <LogoutIcon />}
      onClick={(e) => onClick()}
    >
      {!isActive ? 'Compare Mode' : 'Exit Compare Mode'}
    </Button>
  );
};

export default ComparationToggleButton;
